module.exports = __webpack_public_path__ + "img/logo.b01ba94c.jpg";